import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/chat/error.tsx");
